function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Off"
}, /*#__PURE__*/React.createElement("path", {
  d: "M127.6 0h28.3v99.2h-28.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.2 40.7v29.6c11.2 3.8 20.9 9.3 29 16.4 18.4 16.2 27.7 40.7 27.7 72.8 0 32.1-9.3 56.6-27.7 72.8-17 15-41.7 22.9-71.5 22.9-29.7 0-54.5-7.9-71.5-22.9-18.4-16.2-27.7-40.7-27.7-72.8 0-32.1 9.3-56.6 27.7-72.8 8-7.1 17.8-12.5 28.9-16.4V40.7c-49.5 13.2-85 51.4-85 118.7 0 85.4 57.1 124 127.6 124 70.4 0 127.6-38.6 127.6-124 0-67.3-35.5-105.5-85.1-118.7z"
}))));